
import Vue from 'vue';
import ArticleAuthor from '@root/modules/article/components/authors/ArticleAuthor.vue';
import { Author } from '@root/modules/article/types/article';

interface Props {
  authors: Author[];
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    ArticleAuthor,
  },
  props: {
    authors: {
      type: Array,
      required: true,
    },
  },
});
